import { useQuery } from '@tanstack/react-query';

import { TeamId } from '@suntex.fim/api-client';
import { useFramework } from '@suntex.fim/framework';

// --- Query Keys ---

export const teamRosterKeys = {
  all: ['teamRoster'] as const,
  roster: (teamId: TeamId) =>
    [...teamRosterKeys.all, 'roster', teamId] as const,
  summary: (teamId: TeamId) =>
    [...teamRosterKeys.all, 'summary', teamId] as const,
};

// --- Queries ---

export function useTeamRosterQuery(
  teamId: TeamId,
  options?: { enabled?: boolean },
) {
  const { api } = useFramework();
  return useQuery({
    queryKey: teamRosterKeys.roster(teamId),
    queryFn: () => api.get_Team_Roster({ teamId }),
    enabled: options?.enabled !== false,
  });
}

export function useTeamSummaryQuery(
  teamId: TeamId,
  options?: { enabled?: boolean },
) {
  const { api } = useFramework();
  return useQuery({
    queryKey: teamRosterKeys.summary(teamId),
    queryFn: () => api.get_Team_Team({ teamId }),
    enabled: options?.enabled !== false,
  });
}
